import { createContext } from 'react'
import {
  Etapa,
  PagamentoBoletoResponse,
  PagamentoResumoResponse,
  Parcelamento
} from 'src/api/pagamento'
import { ICartaoForm } from 'src/components/pagamento/cartaoCredito'
import { IDadosPessoais } from 'src/components/pagamento/formDadosPessoais'
import { IOpcaoFluxoPagamento } from 'src/core/consts/opcoesFluxoPagamento'

// ✅ with Type Alias
export type T_FORMAS_PAGAMENTO =
  | 'pix'
  | 'boleto'
  | 'credit_card'
  | 'multiplas'
  | null
export interface IPagamentoContext {
  propostaId?: string
  loading: boolean
  loadingResumo: boolean
  loadingAvulso: boolean
  loadingPagamento: boolean
  loadingPix: boolean
  loadingBoleto: boolean
  loadingCartao: boolean
  existePagamentoFracionado: boolean

  resumo?: PagamentoResumoResponse
  dadosPessoais?: IDadosPessoais
  urlPix?: string
  pixCopiaCola?: string
  pixCopiaColaFracionado?: string
  urlPixFracionado?: string
  pagamentoCreditoFracionado?: boolean
  boleto?: PagamentoBoletoResponse
  boletoFracionado?: PagamentoBoletoResponse
  formaPagamento: T_FORMAS_PAGAMENTO
  parcelamento: Parcelamento
  loadingParcelas: boolean

  activeStep: number
  setActiveStep: (step: number) => void
  opcaoFluxoEscolhida: IOpcaoFluxoPagamento | null
  setOpcaoFluxoEscolhida: (opcao: IOpcaoFluxoPagamento | null) => void
  etapaAtual: Etapa | null

  obterResumoPagamento: (
    propostaId: string,
    loading?: boolean
  ) => Promise<boolean>
  selecionarFormaPagamento: (forma: T_FORMAS_PAGAMENTO) => void
  pagamentoPix: (IPixRequest: IPixRequest) => void
  salvarDadosPessoais: (IDadosPessoaisRequest: IDadosPessoais) => Promise<any>
  pagamentoBoleto: (IBoletoRequest: IBoletoRequest) => void
  pagamentoAvulso: (request: IPagamentoAvulsoRequest) => void
  pagamentoCartaoCredito: (form: ICartaoForm) => void
  copyTextToClipboard: (texto: string) => void
  copiarNumeroBoleto: (boleto?: PagamentoBoletoResponse) => void
  limparFracionado: () => void
  removerPagamentoAvulso: (pedidoId: string) => void
  confirmarPagamentoAvulso: (pedidoId: string) => void
  recusarPagamentoAvulso: (pedidoId: string, motivoRecusa: string) => void
  reiniciarContext: () => void
  obterParcelas: (valor) => Promise<boolean>
}

export interface IPixRequest {
  integral: boolean
  cidade?: string
  cep?: string
  endereco?: string
  estado?: string
  valor?: number
  //Customer
  cpf?: string
  email?: string
  nome?: string
  telefone?: string
  etapa?: 0 | 1 | 2 | 3
}
export interface IBoletoRequest {
  integral: boolean
  cidade?: string
  cep?: string
  endereco?: string
  estado?: string
  valor?: number
  //Customer
  cpf?: string
  email?: string
  nome?: string
  telefone?: string
  etapa?: 0 | 1 | 2 | 3
}
export interface IPagamentoAvulsoRequest {
  pedidoId?: string
  propostaId: string
  dataPagamento: string
  valor: number
  juros?: number
  formaPagamento: string
  meioPagamento: string
  codigoTransacao: string
  urlComprovante?: string
  arquivo?: File
  etapaUnica?: boolean
  etapa?: number
  tipoEtapa?: number
}
const PagamentoContext = createContext<IPagamentoContext>({} as any)

export default PagamentoContext
